/* eslint-disable camelcase */
import {
  InstrumentTypeResponse,
  SideResponse,
} from "../../codegen-api";
import { splitArrayByFilter } from "../../utils/array";
import { IModifiedPosition } from "./model";
import {
  IModifiedNestedOptionPositions,
  IOptionsPositionByAsset,
} from "./types";

export const ACTION_BUTTON_ID = "closePositionRektMeter";

export const getColumnDataKey = (column: any) =>
  String(column?.id || column?.accessor || column?.title || "");

// Sort PnL columns by numeric value so negatives order correctly.
// Non-numeric/empty values sort to the bottom.
export function numericSort(rowA: any, rowB: any, columnId: string) {
  const a = Number(rowA.values[columnId]);
  const b = Number(rowB.values[columnId]);
  const aValid = Number.isFinite(a);
  const bValid = Number.isFinite(b);
  if (!aValid && !bValid) return 0;
  if (!aValid) return -1;
  if (!bValid) return 1;
  return a === b ? 0 : a > b ? 1 : -1;
}

export function buildTablePositions(
  modifiedPositions: IModifiedPosition[]
): IModifiedPosition[] {
  // Split positions into OPTIONS and PERPS
  const [optionPositions, perpsPositions] = splitArrayByFilter(
    modifiedPositions,
    (pos) => !!pos.option
  );

  // Convert option positions into grouped positions
  const optionsPositionByAsset: IOptionsPositionByAsset =
    optionPositions.reduce((acc, position) => {
      if (!position.option?.expiry) {
        return acc;
      }

      if (!acc[position.asset]) {
        // Initialize empty structure
        acc[position.asset] = {
          asset: position.asset,
          expiryPositions: {},
        };
      }

      if (!acc[position.asset].expiryPositions[position.option.expiry]) {
        acc[position.asset] = {
          asset: position.asset,
          expiryPositions: {
            ...acc[position.asset].expiryPositions,
            [position.option.expiry]: {
              expiry: position.option.expiry,
              positions: [],
            },
          },
        };
      }

      // Push
      acc[position.asset].expiryPositions[
        position.option.expiry
      ].positions.push(position);
      return acc;
    }, {} as IOptionsPositionByAsset);

  // Now create all table positions
  const tablePositions: IModifiedPosition[] = [
    ...perpsPositions,
    ...Object.values(optionsPositionByAsset).map(
      (nestedOptionsPos: IModifiedNestedOptionPositions) => {
        const normalModifiedPos: IModifiedPosition = {
          asset: nestedOptionsPos.asset,
          instrument_type: InstrumentTypeResponse.Option,
          nestedOptionsData: nestedOptionsPos.expiryPositions,

          // All these should be ignored by table
          roi: 0,
          amountPrecision: 0,
          pricePrecision: 0,
          positionValue: 0,
          instrument_id: "0",
          instrument_name: "0",
          // option: {},
          // iv: "0",
          amount: "0",
          side: SideResponse.Buy,
          mark_price: "0",
          avg_entry_price: "0",
          unrealized_pnl: "0",
          maintenance_margin: "0",
        };
        return normalModifiedPos;
      }
    ),
  ];
  return tablePositions;
}
